/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.5.25
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WorkorderQueryFromJSON(json) {
    return WorkorderQueryFromJSONTyped(json, false);
}
export function WorkorderQueryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sortColumn': !exists(json, 'sortColumn') ? undefined : json['sortColumn'],
        'sortDirection': !exists(json, 'sortDirection') ? undefined : json['sortDirection'],
        'skip': !exists(json, 'skip') ? undefined : json['skip'],
        'take': !exists(json, 'take') ? undefined : json['take'],
        'omit': !exists(json, 'omit') ? undefined : json['omit'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'campus': !exists(json, 'campus') ? undefined : json['campus'],
        'building': !exists(json, 'building') ? undefined : json['building'],
        'suite': !exists(json, 'suite') ? undefined : json['suite'],
        'floor': !exists(json, 'floor') ? undefined : json['floor'],
        'orderNumber': !exists(json, 'orderNumber') ? undefined : json['orderNumber'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'orderStatus': !exists(json, 'orderStatus') ? undefined : json['orderStatus'],
        'overdueFlag': !exists(json, 'overdueFlag') ? undefined : json['overdueFlag'],
        'workorderId': !exists(json, 'workorderId') ? undefined : json['workorderId'],
        'orderCategory': !exists(json, 'orderCategory') ? undefined : json['orderCategory'],
        'jobType': !exists(json, 'jobType') ? undefined : json['jobType'],
        'trade': !exists(json, 'trade') ? undefined : json['trade'],
        'entryDateStart': !exists(json, 'entryDateStart') ? undefined : (json['entryDateStart'] === null ? null : new Date(json['entryDateStart'])),
        'entryDateEnd': !exists(json, 'entryDateEnd') ? undefined : (json['entryDateEnd'] === null ? null : new Date(json['entryDateEnd'])),
        'startDateStart': !exists(json, 'startDateStart') ? undefined : (json['startDateStart'] === null ? null : new Date(json['startDateStart'])),
        'startDateEnd': !exists(json, 'startDateEnd') ? undefined : (json['startDateEnd'] === null ? null : new Date(json['startDateEnd'])),
        'completionDateStart': !exists(json, 'completionDateStart') ? undefined : (json['completionDateStart'] === null ? null : new Date(json['completionDateStart'])),
        'completionDateEnd': !exists(json, 'completionDateEnd') ? undefined : (json['completionDateEnd'] === null ? null : new Date(json['completionDateEnd'])),
        'contactId': !exists(json, 'contactId') ? undefined : json['contactId'],
        'assignTo': !exists(json, 'assignTo') ? undefined : json['assignTo'],
        'jobPriority': !exists(json, 'jobPriority') ? undefined : json['jobPriority'],
        'setId': !exists(json, 'setId') ? undefined : json['setId'],
        'includeSubStatuses': !exists(json, 'includeSubStatuses') ? undefined : json['includeSubStatuses'],
        'multiAssetDisplay': !exists(json, 'multiAssetDisplay') ? undefined : json['multiAssetDisplay'],
        'orderBy': !exists(json, 'orderBy') ? undefined : json['orderBy'],
        'orderByField2': !exists(json, 'orderByField2') ? undefined : json['orderByField2'],
        'isViewAllRequestersOrdersChecked': !exists(json, 'isViewAllRequestersOrdersChecked') ? undefined : json['isViewAllRequestersOrdersChecked'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}
export function WorkorderQueryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sortColumn': value.sortColumn,
        'sortDirection': value.sortDirection,
        'skip': value.skip,
        'take': value.take,
        'omit': value.omit,
        'propertyId': value.propertyId,
        'campus': value.campus,
        'building': value.building,
        'suite': value.suite,
        'floor': value.floor,
        'orderNumber': value.orderNumber,
        'requestId': value.requestId,
        'orderStatus': value.orderStatus,
        'overdueFlag': value.overdueFlag,
        'workorderId': value.workorderId,
        'orderCategory': value.orderCategory,
        'jobType': value.jobType,
        'trade': value.trade,
        'entryDateStart': value.entryDateStart === undefined ? undefined : (value.entryDateStart === null ? null : value.entryDateStart.toISOString()),
        'entryDateEnd': value.entryDateEnd === undefined ? undefined : (value.entryDateEnd === null ? null : value.entryDateEnd.toISOString()),
        'startDateStart': value.startDateStart === undefined ? undefined : (value.startDateStart === null ? null : value.startDateStart.toISOString()),
        'startDateEnd': value.startDateEnd === undefined ? undefined : (value.startDateEnd === null ? null : value.startDateEnd.toISOString()),
        'completionDateStart': value.completionDateStart === undefined ? undefined : (value.completionDateStart === null ? null : value.completionDateStart.toISOString()),
        'completionDateEnd': value.completionDateEnd === undefined ? undefined : (value.completionDateEnd === null ? null : value.completionDateEnd.toISOString()),
        'contactId': value.contactId,
        'assignTo': value.assignTo,
        'jobPriority': value.jobPriority,
        'setId': value.setId,
        'includeSubStatuses': value.includeSubStatuses,
        'multiAssetDisplay': value.multiAssetDisplay,
        'orderBy': value.orderBy,
        'orderByField2': value.orderByField2,
        'isViewAllRequestersOrdersChecked': value.isViewAllRequestersOrdersChecked,
        'description': value.description,
    };
}
